export default "__VITE_ASSET__DRTRlNWX__"